import { useEffect, useRef } from "react";
import { Polyline } from "@react-google-maps/api";

import type { DetailedLocation } from "../types";

type CustomPolylineProps = {
  path: Array<DetailedLocation>;
};

const CustomPolyline = (props: CustomPolylineProps) => {
  const polylineRef = useRef<google.maps.Polyline>();

  useEffect(() => {
    polylineRef.current?.setVisible(true);
    return () => {
      polylineRef.current?.setVisible(false);
    };
  }, [props.path]);

  const onLoad = (polyline: google.maps.Polyline) => {
    polylineRef.current = polyline;
    polylineRef.current?.setVisible(true);
  };

  return (
    <Polyline
      onLoad={onLoad}
      path={props.path}
      onUnmount={() => {
        polylineRef.current?.setVisible(false);
      }}
      options={{
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2.5,
        zIndex: 1,
      }}
    />
  );
};

export default CustomPolyline;
